<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>

        <router-link class="admin-link" :to="{ path: `/Admin/Blocks`, query: { 'api-Version': apiHeaders['api-Version'] } }">
            &larr; Перейти к списку блоков вопросов
        </router-link>

        <div class="admin-title">
            {{entity.isNew() ? "Создание нового" : "Редактирование"}} блока вопросов
        </div>

        <b-tabs content-class="mt-3">

            <b-tab title="Основная информация">

                <label for="nameBlock">Название блока вопросов</label>
                <b-form-input id="nameBlock" 
                              v-model="entity.Name"
                              placeholder="Введите название блока вопросов" />                
            </b-tab>

            <b-tab title="Вопросы блока">

                <display-block-questions v-model="questionsStartAudit" 
                                         :options="questions" 
                                         :place="placeTypes[0]"
                                         :apiVersion="apiHeaders['api-Version']"/>

                <display-block-questions v-model="questionsAnketa" 
                                         :options="questions" 
                                         :place="placeTypes[1]"
                                         :apiVersion="apiHeaders['api-Version']"/>

                <display-block-questions v-model="questionsEndAudit" 
                                        :options="questions" 
                                        :place="placeTypes[2]"
                                        :apiVersion="apiHeaders['api-Version']"/>

                <display-block-questions v-model="questionsMagnit" 
                                        :options="questions" 
                                        :place="placeTypes[3]"
                                        :apiVersion="apiHeaders['api-Version']"/> 


            </b-tab>

            <b-tab title="Условия для блока вопросов">

                <b-row class="p-0 mt-10">
					<label for="VisibleCondition">Условие:</label>
					<custom-multiselect id="VisibleCondition"
										v-model="entity.VisibleCondition"
										:options="visibleConditionTypes" />
					<hr class="my-4" />

                    <edit-visible-policies v-model="entity.VisiblePolicies"
									       :branches="branches"
                                           :regions="regions"
                                           :questions="parentQuestions"
                                           :networks="networks"
                                           :trade-point-types="ttTypes"
                                           :question-options="questionOptions"
                                           :is-block="true" />
				</b-row>

            </b-tab>

            <b-tab title="Зависимости" v-if="entity.ActivitiesIds && entity.ActivitiesIds.length">

                <b-table bordered class="custom-table-list" :fields="activityFields" :items="entity.ActivitiesIds">
                    <template v-slot:cell(Name)="data">
                         <router-link class="custom-table-list-link" target="_blank" :to="{ path: `/Admin/Activities/Edit?id=${data.item.Id}`, query: { 'api-Version': apiHeaders['api-Version'] } }">
                            {{ data.value }}
                        </router-link>
                    </template>
                </b-table>

            </b-tab>

        </b-tabs>

        <hr class="my-4">

        <b-row class="m-0">

            <b-col lg="2" sm="4" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"
                          @click="save">
                    Сохранить
                </b-button>
            </b-col>

            <!-- <b-col lg="2" sm="4" class="p-0 mr-10">
			    <b-button block v-if="id"
                          id="admin-btn-neutral"
                          class="admin-button" 
                          @click="copyBlockDialog">
                    Скопировать
                </b-button>
            </b-col> -->

            <b-col lg="2" sm="4" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button"
                          @click="deleteBlockDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>

    </b-container>
</template>
<script>
import AllRoutes from '@/routes/all.routes'
import Consts from '@/store/models/consts/adminConsts'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import EditVisiblePolicies from '@/components/admin/questions/EditVisiblePolicies'
import DisplayBlockQuestions from '@/components/admin/blocks/DisplayBlockQuestions'

import BlockEditModel from '@/store/models/admin/blocks/BlockEdit'

export default {
    data: function () {
        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);
        
        let load = new Loading();

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;
        let entity;

        //this.getQuestionOptions(load);
        this.getBranchesAndRegions(load);
        this.getNetworks(load);

        if(id)
            this.getInfo(load, id, apiHeaders);
        else {
            entity = new BlockEditModel();
            this.getQuestions(load, id, apiHeaders);
        }
        
        return {
            load: load,
            id: id,
            entity: entity,
            activities: null,
            placeTypes: Consts.PlaceTypes,
            apiHeaders: apiHeaders,

            branches: [],
            regions: [],
            networks: [],
            ttTypes: Consts.TradePointTypes,
            questions: [],
            questionOptions: [],

            questionsStartAudit: [],
            questionsAnketa: [],
            questionsEndAudit: [],
            questionsMagnit: [],

            visibleConditionTypes: Consts.VisibleConditionTypes,

            activityFields: [ { key: 'Name', label: 'Активности' } ]
        }
    },
    computed: {
        parentQuestions: function() {
            return this.questions.ParentQuestions;
        }
    },
    methods: {
        getInfo: function (load, id, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Blocks.Get(id, apiHeaders)
                .then(response => {
                    this.entity = new BlockEditModel().mapFromDto(response.data);
                    this.getQuestions(load, id, apiHeaders);
                    this.getActivities(load, apiHeaders);
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        // getQuestionOptions: function(load) {
        //     load.Calculate(true);

        //     apiService.Admin.Questions.GetAllOptions()
        //         .then(response => {
        //             this.questionOptions = response.data;
        //             load.Calculate(false);
        //         })
        //         .catch(error => load.Calculate(false));
        // },

         getBranchesAndRegions: function(load) {
            load.Calculate(true);

            apiService.Admin.Branches.GetTerritorialLinks()
                .then(response => {
                    this.branches = response.data.Branches;
                    this.regions = response.data.Regions;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getNetworks: function(load) {
            load.Calculate(true);

            apiService.Admin.TradePoints.GetNetworks()
                .then(response => {
                    this.networks = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getQuestions: function(load, id, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Questions.GetAll(apiHeaders)
                .then(response => {
                    this.questions = response.data;

                    if(id) {
                        this.entity.Questions.forEach(e => {
                            e.Question = this.questions.ParentQuestions.find(p => p.Id == e.Question);

                            let subQuestionsClone = JSON.parse(JSON.stringify(e.SubQuestions));
                            e.SubQuestions = [];

                            subQuestionsClone.forEach(s => {
                                e.SubQuestions.push(this.questions.SubQuestions.find(qs => qs.Id == s));
                            });
                        });

                        this.questionsStartAudit = this.entity.getQuestionsByPlaceType(this.placeTypes[0]);
                        this.questionsAnketa = this.entity.getQuestionsByPlaceType(this.placeTypes[1]);
                        this.questionsEndAudit = this.entity.getQuestionsByPlaceType(this.placeTypes[2]);
                        this.questionsMagnit = this.entity.getQuestionsByPlaceType(this.placeTypes[3]);

                        load.Calculate(true);

                        apiService.Admin.Questions.GetAllOptions(apiHeaders)
                            .then(response => {
                                this.questionOptions = response.data;
                                load.Calculate(false);

                                if(this.entity.VisiblePolicies && this.entity.VisiblePolicies.length) {
                                    this.entity.VisiblePolicies.forEach(e => {
                                        if(e.ParentQuestionId)
                                            e.ParentQuestionId = this.questions.ParentQuestions.find(q => q.Id == e.ParentQuestionId);
                                    });
                                    this.getValueForVisiblePolicies();
                                }
                            })
                            .catch(() => load.Calculate(false));             
                    }         

                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        getValueForVisiblePolicies: function() {
            this.entity.VisiblePolicies.forEach(e => {
                    if(e.RelationType.Id == 1)
                        e.Value = e.getModelValueForAnswerType(this.questionOptions);
                    else
                        e.Value = e.getModelTTValueForConditionType(this.branches, this.regions, this.networks, this.ttTypes);
            });
        },

        getActivities: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Activities.GetAll(apiHeaders)
                .then(response => {
                    this.activities = response.data;
                    this.entity.ActivitiesIds = this.activities.filter(e => this.entity.ActivitiesIds.some(a => a == e.Id));
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        

        save: function () {
            let entityQuestions = this.questionsStartAudit.concat(this.questionsAnketa, this.questionsEndAudit, this.questionsMagnit);

            if (!this.entity.isValid(entityQuestions)) {
                dialogService.showAlert('Предупреждение', 'Для отправки блок должен иметь: 1. Название 2. Хотя-бы один вопрос 3. Заполненные поля\n');
                return;
            }

            this.load.Calculate(true);
            let model = this.entity.mapToDto(entityQuestions);
            apiService.Admin.Blocks.PostUpdate(model, this.apiHeaders)
                .then(() => {
                    this.$router.push({ path: AllRoutes.Admin.Blocks.Index, query: { 'api-Version': this.apiHeaders['api-Version']} });
                })
                .catch(() => this.load.Calculate(false));
        },

        deleteBlockDialog: function() {

            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный блок вопросов?')
                .then(() => {						
                    this.deleteBlock();
                })
                .catch(() => {});
        },
        deleteBlock: function() {
            this.load.Calculate(true);
            apiService.Admin.Blocks.PostDelete(this.entity.Id, this.apiHeaders)
                .then(() => this.$router.push({ path: AllRoutes.Admin.Blocks.Index, query: { 'api-Version': this.apiHeaders['api-Version'] } }))
                .catch(() => this.load.Calculate(false));
        },

        copyBlockDialog: function() {

            dialogService.showConfirm( 'Подтверждение копирования', 'Вы действительно хотите скопировать блок вопросов?')
                .then(() => {						
                    this.copyBlock();
                })
                .catch(() => {});
        },
        copyBlock: function() {
            this.load.Calculate(true);
            apiService.Admin.Blocks.PostCopyBlock(this.entity.Id, this.apiHeaders)
                .then(response => {
                    this.$router.push({ path: AllRoutes.Admin.Blocks.Edit + `?id=${response.data}`, query: { 'api-Version': this.apiHeaders['api-Version'] } });
                })
                .catch(error => {
                    console.log(error);
                    let message = error.response.data ? error.response.data : 'Возникла ошибка на сервере';
                    dialogService.showAlert( 'Ошибка', message);
                    this.load.Calculate(false);
                });
        },

        removeQuestion: function (a) {
            Vue.delete(this.entity.Questions, a);
        },
        updateQuestions: function () {
            for (var i = 0; i < this.entity.Questions.length; i++) {
                var q = this.entity.Questions[i];
                Vue.set(this.entity.Questions[i], q);
            }
        }        
    },
    components: {
        Spinner,
        CustomMultiselect,
        EditVisiblePolicies,
        DisplayBlockQuestions
    }
    
}
</script>
